import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { StyledActionButton } from '../../AfterSalesCtas/CancelSpecificBookingItemsCta/CancelSpecificBookingItemsCta.styles';

const UnselectedOppositeMandatoryReturnWarning = ({ isOpen, closeModal, isDisabled }) => (
  <>
    <StyledActionButton disabled={isDisabled} data-cy="open-forced-refund-button" onClick={closeModal} data-testid="cancel-button">
      <FormattedMessage id="manageBooking.cancelRefund" />
    </StyledActionButton>
    <Modal
      isOpen={isOpen}
      title={<FormattedMessage id="searchResults.cannotBeBooked" />}
      subtitle={<FormattedMessage id="aftersalesWarning.unselectedOppositeMandatoryReturn" />}
      onClose={closeModal}
    ></Modal>
  </>
);

UnselectedOppositeMandatoryReturnWarning.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  isDisabled: PropTypes.bool
};

export default UnselectedOppositeMandatoryReturnWarning;
